/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Directory_Rails_Copy_CodeInputs */

const en_directory_rails_copy_code = /** @type {(inputs: Directory_Rails_Copy_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy discount code ${i?.code}`)
};

const zh_directory_rails_copy_code = /** @type {(inputs: Directory_Rails_Copy_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`复制优惠码 ${i?.code}`)
};

/**
* | output |
* | --- |
* | "Copy discount code {code}" |
*
* @param {Directory_Rails_Copy_CodeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_copy_code = /** @type {((inputs: Directory_Rails_Copy_CodeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Copy_CodeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_copy_code(inputs)
	return zh_directory_rails_copy_code(inputs)
});
export { directory_rails_copy_code as "directory.rails.copy_code" }